import { Component, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { StructureViewColumnConfig } from "../../../models";
import { NestedTableRowComponent } from "./nested-table-row/nested-table-row";

@Component({
  selector: "adaa-nested-table",
  imports: [TranslatePipe, NestedTableRowComponent],
  templateUrl: "./nested-table.html",
  styleUrl: "./nested-table.scss",
})
export class NestedTableComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data = input.required<any[]>();
  columns = input.required<StructureViewColumnConfig[]>();
  periodId = input.required<number>();
  useGovScoresConfig = input<boolean>(false);
}
